<template>
  <h3 class="creafix">
    <div
      v-for="(item, index) in triggerval.chooseVal"
      :key="item"
      @click="chooseInfo(index)"
      :class="{ choose: true, active: triggerval.chooseIndex == index }"
    >
      {{ item }}
      <span class="line"></span>
    </div>
    <div
      :class="{ applyStatus: true, fr: true, 'font-blue': isblue }"
      @click="changeyours"
    >
      {{ titlevalue }}
    </div>
  </h3>
</template>

<script>
export default {
  props: {
    triggerval: Object,
    isblue: {
      type: Boolean,
      default: false
    },
    titlevalue: {
      type: String,
      default: ""
    }
  },
  methods: {
    // 切换信息函数
    chooseInfo(index) {
      this.triggerval.chooseIndex = index;
    },
    changeyours() {
      this.$emit("changeyours", true);
    }
  }
};
</script>
<style lang="stylus" scoped>
h3
    .font-blue
        color #48A2DF
</style>
